import { Textfield as DigdirTextfield, } from "@digdir/designsystemet-react";
const Textfield = DigdirTextfield;
Textfield.displayName = "Textfield";
export { Textfield };
//# sourceMappingURL=textfield.js.map